import { connect, useDispatch } from 'react-redux'
import AccountInfo from '../../../containers/authorised/patientPartials/AccountInformationPartial'
import SocialHistory from '../../../containers/authorised/appointment/SocialHistory'
import MedicalHistory from '../../../containers/authorised/appointment/MedicalHistory'
import ReviewOfSystem from '../../../containers/authorised/appointment/ReviewOfSystem'
import Document from '../../../containers/authorised/appointment/Documents'
import { patientSocialHistoriesLoad } from '../../../redux/actions/patient/patientSocialHistoryActions';
import { socialHistoriesLoad as settingSocialHistoriesLoad } from '../../../itrust_common/redux/actions/settingActions/socialHistoryActions';
import { patientMedicalHistoriesLoad } from '../../../redux/actions/patient/patientMedicalHistoryActions';
import { patientReviewOfSystemsLoad } from '../../../redux/actions/patient/patientReviewOfSystemActions';
import { reviewOfSystemsLoad } from '../../../itrust_common/redux/actions/settingActions/reviewOfSystemActions';
import { patientDocumentsLoad } from '../../../redux/actions/patient/patientDocumentActions';
import { initializePatientTemplateAttributes } from '../../../itrust_common/components/HelperFunctions';
import { patientEdit } from '../../../redux/actions/patient/patientActions';
import { useEffect } from 'react'

function PatientDetailsForm(props) {
  const { patient, quickActionPatient, isQuickAction, wrapperClasses, formType, patientTemplate } = props;
  const tabsVisible = isQuickAction ? (quickActionPatient.id && quickActionPatient.id == 'New') : !patient.id
  const dispatch = useDispatch()

  useEffect(() => {
    if (formType === "new") {
      let patientData = initializePatientTemplateAttributes(patientTemplate.personal_information)
      dispatch(patientEdit(patient.id, patientData));
    }
  }, [])

  const handleSocialHistoryLoad = () => {
    dispatch(settingSocialHistoriesLoad({ sort: 'category, position' }));
    dispatch(patientSocialHistoriesLoad(patient.id));
  }

  const handleMedicalHistoryLoad = () => {
    dispatch(patientMedicalHistoriesLoad(patient.id));
  }

  const handleReviewOfSystemLoad = () => {
    dispatch(reviewOfSystemsLoad({ rpp: 9999999 }))
    dispatch(patientReviewOfSystemsLoad(patient.id));
  }

  const handleDocumentsLoad = () => {
    dispatch(patientDocumentsLoad(patient.id, { include: ['document', 'tags'] }));
  }

  return (
    <div className="w-75 overflow-auto" style={{ minHeight: '58.5rem' }}>
      <div className={`fixed-container-modal px-5 bg-light pt-9 w-75 ${wrapperClasses}`}>
        <div className="d-flex flex-row align-items-center justify-content-between">
          <h5>Patient Details</h5>
        </div>
        <div className="border-bottom border-light">
          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item">
              <a className="py-5 pl-0 pr-7 tab-link active" id="account-info-tab" data-toggle="tab" href="#account-info" role="tab" aria-controls="account-info" aria-selected="true">
                Account information
              </a>
            </li>
            {(patient && !isQuickAction) &&
              <>
                <li className="nav-item">
                  <a className={`py-5 pl-0 pr-7 tab-link ${tabsVisible && 'disabled'}`} id="social-history-tab" data-toggle="tab" href="#social-history" role="tab" aria-controls="social-history" aria-selected="false" onClick={() => handleSocialHistoryLoad()}>
                    Social History
                  </a>
                </li>
                <li className="nav-item">
                  <a className={`py-5 pl-0 pr-7 tab-link ${tabsVisible && 'disabled'}`} id="medical-history-tab" data-toggle="tab" href="#medical-history" role="tab" aria-controls="medical-history" aria-selected="false" onClick={() => handleMedicalHistoryLoad()}>
                    Medical History
                  </a>
                </li>
                <li className="nav-item">
                  <a className={`py-5 pl-0 pr-7 tab-link ${tabsVisible && 'disabled'}`} id="review-of-system-tab" data-toggle="tab" href="#review-of-system" role="tab" aria-controls="review-of-system" aria-selected="false" onClick={() => handleReviewOfSystemLoad()}>
                    Review Of Systems
                  </a>
                </li>
                <li className="nav-item">
                  <a className={`py-5 pl-0 pr-7 tab-link ${tabsVisible && 'disabled'}`} id="document-tab" data-toggle="tab" href="#document" role="tab" aria-controls="document" aria-selected="false" onClick={() => handleDocumentsLoad()}>
                    Attached Docs
                  </a>
                </li>
              </>}
          </ul>
        </div>
      </div>
      <div className="middle-container-modal px-5 mb-9">
        <div className="tab-content">
          <div className="tab-pane active" id="account-info" role="tabpanel" aria-labelledby="account-info-tab">
            <AccountInfo isQuickAction={isQuickAction} accountInfoWidth="col-lg-8"/>
          </div>
          {patient && patient.id &&
            <>
              <div className="tab-pane" id="social-history" role="tabpanel" aria-labelledby="social-history-tab">
                <SocialHistory patientId={patient.id} />
              </div>
              <div className="tab-pane" id="medical-history" role="tabpanel" aria-labelledby="medical-history-tab">
                <MedicalHistory patientId={patient.id} />
              </div>
              <div className="tab-pane" id="review-of-system" role="tabpanel" aria-labelledby="review-of-system-tab">
                <ReviewOfSystem patientId={patient.id} />
              </div>
              <div className="tab-pane" id="document" role="tabpanel" aria-labelledby="document-tab">
                <Document patientId={patient.id} />
              </div>
            </>
          }
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  const { patient, setting, appointment, dashboard: { quickAction } } = state
  return {
    patient: patient.patient,
    quickActionPatient: quickAction.patient,
    formType: appointment.handlerData.formType,
    patientTemplate: setting.patientTemplate.patient_template
  }
}
export default connect(mapStateToProps)(PatientDetailsForm);
